import React, { useState, useEffect } from 'react';
import { get } from './axios_call';
import ModelsGallery from '../elements/model/ModelsGallery';

export default (type, category, viewSize) => {
  const [models, setModels] = useState(null);
  useEffect(() => {
    let sourceOuter;
    get(`representatives/${type}/${category}`, false)
      .then(([res, source]) => {
        sourceOuter = source;
        setModels(
          res.data.map((model) => <ModelsGallery model={model} type={type} category={category} key={`${model.firstName} ${model.lastName}`} viewSize={viewSize} />),
        );
      });
    return () => {
      sourceOuter.cancel();
      setModels(null);
    };
  }, [type, category, viewSize]);
  return models;
};
